// ----------------------------------------------------------------------
// Single source of truth for the degree verification contact channel.
// Keep in sync with src/components/contact-support.tsx
// ----------------------------------------------------------------------

export const VERIFICATION_EMAIL = 'registrar.office@ttu.edu.vn';
